import "./Backoffice.scss";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../components/Button";
import Dots from "react-activity/dist/Dots";

function Backoffice() {
  const navigate = useNavigate();
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://tell-me-more-backend-nyfc.onrender.com/form"
        );
        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error.response);
      }
    };
    fetchData();
  }, []);

  return isLoading ? (
    <Dots />
  ) : (
    <div className="backContainer">
      <h1>Formulaires</h1>
      <div className="allFormBoxes">
        <div
          className="formBox newForm"
          onClick={() => {
            navigate("/backoffice/create");
          }}
        >
          <div className="large">+</div>
          <div>Nouveau formulaire</div>
        </div>
        {data.map((form, index) => {
          return (
            <div key={index} className="formBox existingForm">
              <div className="formBoxTop">
                <div>FORMULAIRE</div>
                <Link
                  className="link"
                  to={`/form/${form.slug}`}
                  target="_blank"
                >
                  Go
                </Link>
              </div>
              <div className="formTitle">
                <h2>{form.title}</h2>
              </div>
              <div className="formBoxBottom">
                <Link className="link" to={`/backoffice/update/${form._id}`}>
                  Editer
                </Link>
                <Button
                  text={"Voir les réponses"}
                  color={"green"}
                  func={() => {
                    navigate(`/backoffice/answers/${form._id}`);
                  }}
                  show={true}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Backoffice;
